export type API_TEmployee = {
  id: number;
  job_title: string;
  name: string;
};

export type TEmployee = {
  value: number;
  label: string;
  sublabel: string;
};

export const convertEmployees = (a: API_TEmployee): TEmployee => {
  return {
    value: a.id,
    label: a.name,
    sublabel: a.job_title,
  } as TEmployee;
};
